import { render } from "./page1.vue?vue&type=template&id=477abd37&scoped=true"
import script from "./page1.vue?vue&type=script&lang=js"
export * from "./page1.vue?vue&type=script&lang=js"

import "./page1.vue?vue&type=style&index=0&id=477abd37&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ThinleyNorbu\\source\\repos\\1185_BF_Module_0\\vueOktaVersion\\custom-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477abd37"]])

export default __exports__